import { create } from 'zustand'

interface InterestCountsState {
  counts: Record<string, number>
  // Ref-count de cuántos InterestButton montados están mostrando cada slug
  // — el poller solo pide conteos de slugs con al menos 1 registro.
  registered: Record<string, number>
  seed: (slug: string, count: number) => void
  setCount: (slug: string, count: number) => void
  mergeCounts: (counts: Record<string, number>) => void
  register: (slug: string) => void
  unregister: (slug: string) => void
}

export const useInterestCountsStore = create<InterestCountsState>((set, get) => ({
  counts: {},
  registered: {},

  // Solo inicializa si no hay un valor ya conocido (evita pisar un conteo
  // más reciente ya obtenido por polling/toggle con el prop inicial, más
  // viejo, de un remount).
  seed: (slug, count) => {
    if (get().counts[slug] !== undefined) return
    set((state) => ({ counts: { ...state.counts, [slug]: count } }))
  },

  setCount: (slug, count) =>
    set((state) => ({ counts: { ...state.counts, [slug]: count } })),

  mergeCounts: (counts) =>
    set((state) => ({ counts: { ...state.counts, ...counts } })),

  register: (slug) =>
    set((state) => ({
      registered: { ...state.registered, [slug]: (state.registered[slug] ?? 0) + 1 },
    })),

  unregister: (slug) =>
    set((state) => {
      const next = (state.registered[slug] ?? 1) - 1
      const registered = { ...state.registered }
      if (next <= 0) delete registered[slug]
      else registered[slug] = next
      return { registered }
    }),
}))
